import { Component, OnInit, Input , OnChanges, SimpleChanges } from '@angular/core';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { ManualApproval } from '../../../models/ApprovalManual.model';
import { DropDownList } from '../../../models/DropDownList.model';

@Component({
  selector: 'app-create-approval-box',
  templateUrl: './create-approval-box.component.html',
  styleUrls: ['./create-approval-box.component.scss']
})
export class CreateApprovalBoxComponent implements OnInit {
  @Input() approval;
  @Input() consultantsBorrowInvoice;
  mensalHours: number = 0;
  hourValue: number = 0;
  contractTotalValue: number = 0;
  kind: number = 0;
  honorarium: number = 0;
  active: boolean = false;
  borrowInvoice: boolean = false;

  constructor(public commonHelper:CommonHelper) { }

  ngOnInit(){
      this.setValues(this.approval)
      this.approval.manualApproval = {  created:false,
                                        totalEdited:false,
                                        hoursEdited:false
                                    }
      this.approval.manualApproval.created = true;
      this.approval.borrowedInvoice = {
        _id: '',
        sapCardCode: '',
        sapServiceCode: '',
        cnpj: ''
      }
  }

    valueCheck(projectHours, totalValue){
        if(Math.abs(projectHours - totalValue)<= 1){
            return true;
        }
        return false;
    }

    calculate() {
            this.approval.manualApproval.hoursEdited = true;
            this.approval.realizedHours = 0;
            this.approval.projects.forEach(project =>{
                this.approval.realizedHours += project.total_hours;
                project.approvedHours = project.total_hours;
                project.approvedValue = (project.total_hours && this.approval.consultant.contract.hourValue)?(project.total_hours*this.approval.consultant.contract.hourValue):0;
            });
            this.approval.totalHourValue = 0;
            this.approval.totalSoldHourValue = 0;
            this.approval.totalHourValue = this.approval.consultant.contract.hourValue * this.approval.realizedHours;
            this.approval.totalValue = this.valueCheck(this.approval.totalHourValue,this.approval.consultant.contract.totalValue.valueOf())?this.approval.consultant.contract.totalValue.valueOf():this.approval.totalHourValue;
            this.approval.totalSoldHourValue = this.approval.consultant.contract.soldHourValue * this.approval.realizedHours;
    }
    
    setValues(approval){
        if(approval.consultant.contract.mensalHours)
            this.mensalHours = approval.consultant.contract.mensalHours;

        this.hourValue = approval.consultant.contract.hourValue;

        if(approval.consultant.contract.totalValue)
            this.contractTotalValue = approval.consultant.contract.totalValue;

        this.kind = approval.consultant.contract.kind;

        if(approval.consultant.contract.honorarium)
            this.honorarium = approval.consultant.contract.honorarium;

        if(approval.consultant.active)
            this.active = approval.consultant.active

    }

    calculateProjectValue(){
        this.approval.manualApproval.totalEdited = true;
        this.approval.projects.forEach(project =>{
            project.approvedValue = (this.approval.totalValue/this.approval.realizedHours)*project.total_hours;
        });
    }

    getHonorarium() {
        if(this.honorarium){
            switch(this.honorarium){
                case 1:
                    return 'Hora Aberta';
                case 2:
                    return 'Hora Fechada';
            }
        }else{
            return null;
        }
    }

    onClickExtras(){
        if(this.approval.extras == true){
            this.approval.discountHours = 0;
            this.approval.discounted = false;
            this.approval.discountValue = 0;
        }
    }
    
    onClickDiscount(){
        if(this.approval.discounted == true){
            this.approval.extras = false;
            this.approval.extrasHours = 0;
            this.approval.extrasValue = 0;
        }
    }

    changeBorrow(){
        if(!this.borrowInvoice)
            this.clearBorrow()
    }

    changeConsultantBorrow(){
        if(this.approval.borrowedInvoice._id == ''){
            this.clearBorrow()
        } else {
            const borrowdInvoice = this.consultantsBorrowInvoice.find(cb => cb._id == this.approval.borrowedInvoice._id)
            this.approval.borrowedInvoice.sapCardCode = borrowdInvoice.sapCardCode;
            this.approval.borrowedInvoice.sapServiceCode = borrowdInvoice.contract.sapServiceCode;
            this.approval.borrowedInvoice.cnpj = borrowdInvoice.contract.cnpj;
        }
    }

    clearBorrow(){
        this.approval.borrowedInvoice._id = ''
        this.approval.borrowedInvoice.sapCardCode = ''
        this.approval.borrowedInvoice.sapServiceCode = ''
        this.approval.borrowedInvoice.cnpj = ''
    }

    isActive(active: boolean) {
        return active ? "badge-success" : "badge-danger";
    }

    isActiveText(active: boolean) {
        return active ? "Consultor Ativo" : "Consultor Inativo";
    }
}



// WEBPACK FOOTER //
// ./src/app/views/approvals/create-approval-box/create-approval-box.component.ts